import { makeStyles } from "@material-ui/core";
import { Color } from "../../../../theme";
import { GroupBase, MenuProps, components } from "react-select5";
import cns from "classnames";

export function MenuComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: MenuProps<Option, IsMulti, Group>) {
  const classes = useStyles();
  const { children, ...rest } = props;

  // @ts-expect-error recommended way to pass component props in
  // https://react-select.com/components#defining-components
  const prependedChildren = rest.selectProps.menuChildren?.prependedChildren;
  // @ts-expect-error recommended way to pass component props in
  const appendedChildren = rest.selectProps.menuChildren?.appendedChildren;

  return (
    <components.Menu {...rest}>
      {prependedChildren && (
        <div
          className={cns(classes.childWrapper, classes.childWrapperTop)}
          style={{
            borderBottom: `1px solid ${Color.LightGray}`,
            borderRadius: "4px 4px 0 0"
          }}
        >
          {prependedChildren}
        </div>
      )}
      {children}
      {appendedChildren && (
        <div className={cns(classes.childWrapper, classes.childWrapperBottom)}>
          {appendedChildren}
        </div>
      )}
    </components.Menu>
  );
}

const useStyles = makeStyles((theme) => ({
  childWrapper: {
    height: "100%",
    padding: "0.5rem",
    backgroundColor: theme.palette.background.default
  },
  childWrapperTop: {
    borderBottom: `1px solid ${Color.LightGray}`,
    borderRadius: "4px 4px 0 0"
  },
  childWrapperBottom: {
    borderTop: `1px solid ${Color.LightGray}`,
    borderRadius: "0 0 4px 4px"
  }
}));
